
<template>
  <div class="mask"></div>
</template>

<script>
import { wxband } from "@/api/wxband";
export default {
  data() {
    return {
      code: "",
      state: ""
    };
  },
  created() {
    document.title = "结果页";

    var oHead = document.getElementsByTagName("HEAD").item(0);
    var oScript = document.createElement("script");
    oScript.type = "text/javascript";
    oScript.setAttribute("async", true);
    oScript.src = "//g.alicdn.com/sd/ncpc/nc.js?t=" + new Date().getTime();
    oHead.appendChild(oScript);
    this.code = this.getUrlParamValue("code");
    this.state = this.getUrlParamValue("state");
    wxband({ code: this.code, state: this.state })
      .then(res => {
        console.log(res.data.msg);
        this.getConfirm(res.data.msg);
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    getConfirm(e) {
      confirm(e);
      window.opener = null;
      window.open("", "_self");
      window.close();
      WeixinJSBridge.call("closeWindow"); //微信
      AlipayJSBridge.call("closeWebview"); //支付宝 关闭窗口（别名）
      BLightApp.closeWindow(); //百度钱包
    },
    getUrlParamValue(name) {
      if (name == null || name == "undefined") {
        return null;
      }

      var searchStr = decodeURI(location.search);

      var infoIndex = searchStr.indexOf(name + "=");

      if (infoIndex == -1) {
        return null;
      }

      var searchInfo = searchStr.substring(infoIndex + name.length + 1);

      var tagIndex = searchInfo.indexOf("&");

      if (tagIndex != -1) {
        searchInfo = searchInfo.substring(0, tagIndex);
      }

      return searchInfo;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/wxband.vue